window.$ = window.jQuery = require('jquery');
require('jquery-ui/ui/widgets/slider');